// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/ImageComentator/ImageComentator.sass
// module id = 423
// module chunks = 0